import { Controller } from "@hotwired/stimulus";

// Targeting one person ignores the platform and version filters, which makes person mode
// exclusive. A list narrows the segment, which is why list mode keeps the filters too.
// Hiding the inactive side is not enough, because a value left behind in a hidden input
// still posts and would silently retarget the send. Disabling it makes the browser leave
// it out of the submission entirely.
export default class extends Controller {
  static targets = ["mode", "segment", "list", "person"];

  connect() {
    this.apply();
  }

  apply() {
    const mode = this.modeTargets.find((target) => target.checked)?.value;

    this.setActive(this.segmentTarget, mode !== "person");
    this.setActive(this.listTarget, mode === "list");
    this.setActive(this.personTarget, mode === "person");
  }

  setActive(panel, active) {
    panel.classList.toggle("hidden", !active);
    panel.querySelectorAll("input, select, textarea").forEach((field) => {
      field.disabled = !active;
    });
  }
}
